import { Component, OnInit } from '@angular/core';
import { Interest, EditInterest } from './../../../../models/inModels/Interest';
import { Message } from "primeng/components/common/message";
import { SelectItem } from "primeng/components/common/selectitem";
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { StorageService } from "../../../../services/system/storage.service";
import { InterestsService } from '../../../../services/business/interests.service';

@Component({
  selector: 'app-interests-edit',
  templateUrl: './interests-edit.component.html',
  styleUrls: ['./interests-edit.component.css']
})
export class InterestsEditComponent implements OnInit {
  id;
	model: EditInterest ;
	loading = false;
	error: Message[];
  messages: Message[];
  interests: SelectItem[];
  uploading = false;
  
  constructor(private interestService: InterestsService,
              private storageService: StorageService,
	          	private route: ActivatedRoute,
              private router: Router) {
      console.log(this.route.snapshot.paramMap.get('Id'));
      this.id = this.route.snapshot.paramMap.get('Id');
               }

  ngOnInit() {
    this.getInterest();
  }

  getInterest() {
    this.loading = true;
    this.interestService.get(this.id).then(
      res => {
        this.model = new EditInterest(res);
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }

  goBack(): void {
    this.router.navigate(['/interests']);
  }
  
  save(){
    this.loading = true;
    this.interestService.update(this.model).then(
      res => {
        this.loading = false;
        this.model = new EditInterest(res);
        this.messages = [];
        this.messages.push({ severity: 'success', summary: 'Success', detail: 'Interest Updated'});
      },
      error => {
        this.loading = false;
        this.messages =[];
        this.messages.push({ severity: 'error', summary: 'Error', detail: error });;
      });
   }


}



// WEBPACK FOOTER //
// ./src/app/components/sales/interests/interests-edit/interests-edit.component.ts